import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { apiEndPoints, clearStorage } from "../../config/config";
import useSummary from "../../hooks/summary/useSummary";
import CardShimmer from "../../modules/molecules/shimmer/card/main";
import ReportCard from "./components/report_card/main";
import AnimatedSuperSetCard from "./components/animation/main";
import { updateSubroute } from "../../store/route_slice";
import dayjs from "dayjs";
import { trackEvent } from "../../amplitude/amplitude";
import { stateType } from "../../store/store.type";
import APIError from "../../api/Error/error";
import { updateErrorMessage } from "../../store/error_slice";
import { Typography } from "../../modules/molecules/mui/main";

export default function Reports() {
  const dispatch = useDispatch();

  const { subRoute: route } = useSelector(
    (sel: stateType) => sel.subRouteSlice.route.reports,
  );
  const onSucces = (data: {
    success: boolean;
    guest_token: string;
    dashboard: {
      id: number;
      title: string;
      description: string;
      dashboard_eid: string;
      icon_url: null | string;
    }[];
  }) => {
    const token = localStorage.getItem("superset_token");
    if (token) {
      localStorage.removeItem("superset_token");
      localStorage.removeItem("superset_token_expiry");
    }

    localStorage.setItem("superset_token", data.guest_token);
    localStorage.setItem("superset_token_expiry", dayjs().toString());
  };
  const onError = (error: APIError) => {
    try {
      if (error.statusCode === 401) {
        //logout
        clearStorage();
        window.location.reload();
      }
      //   else if (superSetErrorMessage) return;
      else {
        dispatch(updateErrorMessage({ message: error.message }));
      }
    } catch (err) {
      dispatch(updateErrorMessage({ message: "Something went wrong" }));
    }
  };
  const url = apiEndPoints.SUPER_SET;
  const { isLoading, isError, data, isFetching, refetch } = useSummary({
    onSucces,
    onError,
    url,
    queryKey: ["superset-token"],
  });

  useEffect(() => {
    trackEvent({ eventName: "Page navigation" });

    if (
      dayjs().diff(
        dayjs(localStorage.getItem("superset_token_expiry")),
        "minutes",
      ) >= 30
    ) {
      if (route) {
        dispatch(updateSubroute({ parent: "reports", subRoute: "" }));
      }
      refetch();
    }
  }, [route]);

  return (
    <Box
      sx={{
        height: route === "" ? "1000px" : "",
        padding: "1.75rem 0.75rem 0rem 1.75rem",
      }}
    >
      {
        <Grid container gap={3}>
          {isLoading || isFetching || isError ? (
            new Array(12)
              .fill(0)
              .map((_, index) => (
                <CardShimmer
                  borderRadius={"1rem"}
                  color={"#F7F9FB"}
                  width={"100%"}
                  height={"12.875rem"}
                  dataTestId={"super-shimmer"}
                  xs={"5.5"}
                  md={"3.75"}
                  key={index + "shimmer"}
                />
              ))
          ) : data?.dashboard.length === 0 ? (
            <Typography sx={{ fontWeight: "300", fontSize: "0.875rem" }}>
              No Reports Found!
            </Typography>
          ) : (
            data?.dashboard.map(
              (e: {
                id: number;
                dashboard_eid: string;
                description: string;
                title: string;
                icon_url: string;
              }) => {
                if (route === `${e.dashboard_eid}`) {
                  return (
                    <AnimatedSuperSetCard
                      title={e.title}
                      discription={e.description}
                      imageUrl={e.icon_url}
                      id={`${e.dashboard_eid}`}
                      onClick={() => {}}
                      expanded={route !== ""}
                      key={`${e.dashboard_eid}-expaneded`}
                    />
                  );
                } else if (route !== `${e.dashboard_eid}` && route !== "") {
                  return;
                } else {
                  return (
                    // eslint-disable-next-line react/jsx-key
                    <Grid item xs={5.5} md={3.75}>
                      <ReportCard
                        title={e.title}
                        discription={e.description}
                        imageUrl={e.icon_url}
                        id={`${e.dashboard_eid}`}
                        onClick={() => {}}
                        expanded={route !== ""}
                        key={`${e.dashboard_eid}-collapsed`}
                      />
                    </Grid>
                  );
                }
              },
            )
          )}
        </Grid>
      }
    </Box>
  );
}
